import { keepPreviousData } from '@tanstack/react-query'
import { useUserQuery } from 'auth/hooks'

export function useUserAvatarQuery() {
  return useUserQuery(undefined, {
    placeholderData: keepPreviousData,
    select(data) {
      const user = data.me?.user
      const initials = [user?.firstName?.charAt(0), user?.lastName?.charAt(0)].join('')
      return {
        initials,
        hasImage: Boolean(user?.avatarUrl),
        avatarUrl: user?.avatarUrl,
      }
    },
  })
}
